<span
    [ngbPopover]="popoverTemplate"
    placement="auto"
    class="cm-link"
    #popover="ngbPopover"
    triggers="manual"
    (click)="openPopover(popover)"
>
    Attachments
    <ng-template #popoverTemplate>
        <cm-popover-layout [popover]="popover">
            <span popover-layout="header">Attachments</span>
            <div popover-layout="body" *ngFor="let attachment of attachments">
                <a href="javascript:void(0);" (click)="openFilePreview(attachment)" class="cm-link">{{
                    attachment.file_name
                }}</a>
            </div>
        </cm-popover-layout>
    </ng-template>
</span>
